export class BulkInsertModel {
    itemIds: Array<number>;
    jurisdictions: Array<string>;
    id:number;
    parentId:number;
    screenUrl:string;
    templateNo:number;
    constructor() {
        this.itemIds = [];
        this.jurisdictions = [];
        this.id=0;
        this.parentId=0;
        this.screenUrl='';
        this.templateNo = 0;
    }
}
